/**
 * B2B-specific Vuetify customizations.
 *
 * This plugin runs after the fire-framework vuetify plugin (from the layer),
 * so any aliases/defaults added here will extend or override the framework ones.
 *
 * Use this to add aliases, defaults, or other Vuetify options that are specific
 * to the fire-b2b app and should NOT live in the shared framework package.
 */
import { VBtn } from 'vuetify/components'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vuetify:before-create', (vuetify) => {
    vuetify.vuetifyOptions.aliases = {
      ...vuetify.vuetifyOptions.aliases,
      VBtnCheckout: VBtn,
    }
    vuetify.vuetifyOptions.defaults = {
      ...vuetify.vuetifyOptions.defaults,
      VBtnCheckout: {
        color: 'secondary',
        variant: 'flat',
        size: 'large',
      },
    }
  })
})
